import React, { useState, useEffect } from 'react'
import RegisteredUsers from '../../NotificationMenu/RegisteredUsers';
import EmergencyContact from '../../NotificationMenu/EmergencyContact';
import CustomContact from '../../NotificationMenu/CustomContact';
import EditModalContainer from '../../NotificationMenu/EditModalContainer';
import { Accordion, Card, Tab, Tabs } from "react-bootstrap";
import { Mention, MentionsInput } from "react-mentions";
import CustomAccordion from './CustomAccordion';
import { DatePicker } from 'rsuite';
import mentionsInputStyles from "../../NotificationMenu/mentionsInputStyles";
import mentionStyles from "../../NotificationMenu/mentionStyles"
import { AddNode, ArrowDown, ArrowUp, DropArrow, SearchIcon, SearchIconWhite } from "../../../assets/images";
import { getEmergencyContactList } from '../../../services/notifService';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { WarningToast } from '../../../CustomHooks/WarningToast';

const EscalationAccordian = ({
    setIsNotifFormEnabled,
    handleTimeChange,
    siteSelected,
    setSiteSelected,
    isDarkTheme,
    setsubjectEmailMessage,
    // categoryMaster,
    // setCategoryMaster,
    // siteListString,
    // emergencyContactList,
    // setEmergencyContactList,
    mentionList,
    setMentionList,
    setMentionSubjectEmailMessage,
    mentionSubjectEmailMessage,
    setemailMessage,
    setMentionEmailMessage,
    setSmsMessage,
    setMentionSMSMessage,
    setmobileMessage,
    setMentionMobileMessage,
    subjectEmailMessage,
    emailMessage,
    smsMessage,
    mobileMessage,
    // selectedUsersList,
    // setSelectedUsersList,
    // setSelectedAllRegUsers,
    // selectedAllRegUsers,
    waitTime,
    setWaitTime,
    userList,
    setUserList,
    addNewClicked,
    // count,
    setEscalationLevelName,
    escalationLevelName,
    setEscalationLevels,
    escalationLevels ,
    setEscalationLevelNameError ,
    escalationLevelNameError,
    updateParentMainCustomerList,
    parentMainCustomerList,
    parentCount,
    updateParentCount,
    parentCustomContact,
    updateParentCustomContact,
    // onAddClick,
    // onDeleteClick,
    isNotifFormEnabled,
    selectedEntity,
    isEditCustomer,
    setTopLeftCheck,
    topLeftCheck,
    selectAllHandler,
    searchHandlerOne,
    midLeftCheck,
    setMidLeftCheck,
    // mainCustomerList,
    // setMainCustomerList,
    // setEnableAdd,
    subjectHandler ,
    messageHandler,
    handleAddLevel,
    handleRemoveLevel,
    level,
    accOpen,
    setAccOpen,
    handleAccordionToggle,
    handleLevelChange,
    parentSelectedUsersList,
    updateParentSelectedUsersList,
    activeTab,
    parentEmergencyContact,
    updateParentEmergencyContact
}) => { 
    // Register User
    const [tempCount, setTempCount] = useState(0);
    const [selectedAllRegUsers, setSelectedAllRegUsers] = useState(false);
    const [selectedUsersList, setSelectedUsersList] = useState([]);
    const [siteListString, setSiteListString] = useState("");
    const [transformedData, setTransformedData] = useState([]);

    // Emergency Contact 
    const [emergencyContactList, setEmergencyContactList] = useState([])
    const [categoryMaster, setCategoryMaster] = useState([])
    const [selectedEmergCont, setSelectedEmergCont] = useState([
        {
          categoryChecked: 1,
          contactLevels: ["1", "3"]
        }
    ]);

 // Custom Contact Region UseState
    const [count, setCount] = useState(0);
    const [enableAdd, setEnableAdd] = useState(false);
    const [mainCustomerList, setMainCustomerList] = useState([
        {
          Id: 0,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        },
      ]);
    const [customContact, setCustomContact] = useState([
        {
          Id: 0,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        },
      ]);
    const [tempCustomContact, setTempCustomContact] = useState([]);

  
    // For Register User List
      // useEffect(() => {
      //   console.log("parentSelectedUsersList", parentSelectedUsersList)
      // }, [parentSelectedUsersList])

    useEffect(() => {
       let temp = siteSelected.map((item) => item.value).join(",");
       let oldString = siteListString;
       let oldArr = siteListString.split(",");
       let newArr = temp.split(",");
       if (oldArr.length > newArr.length) {
         let diff = oldArr.filter((e) => !newArr.includes(e));
         let anotherTempArr = selectedUsersList;
         for (let i = 0; i < diff.length; i++) {
           anotherTempArr = anotherTempArr.filter((item) => item.Item2 != diff[i]);
         }
         setSelectedUsersList(anotherTempArr);
        //  updateParentSelectedUsersList(anotherTempArr)
       }
       setSiteListString(temp);
    }, [siteSelected]);

    
    useEffect(() => {
        if (siteListString != "") {
              let temp;
              let loggedInUser = JSON.parse(localStorage.getItem('user'))
              temp = loggedInUser?.Id
              getEmergencyContactList(temp, siteListString).then((res) => {
                if (res.Status == "success") {
                  let arr = res.Data.map((item) => {
                    let obj = {
                      "Category": item.Category,
                      "CategorySelected": false,
                      "ContactLevel": item.ContactLevel.map(contactId => ({
                        "contactId": contactId,
                        "contactSelected": false
                      }))
                    }
                    return obj
                  });
        
                  let tempArr = arr.map((item) => {
                    let obj
                    let isPresent = false
                    let str = []
                    for (let i = 0; i < selectedEmergCont.length; i++) {
                        if (item.Category == selectedEmergCont[i].categoryChecked) {
                            isPresent = true
                            str = selectedEmergCont[i].contactLevels
                            break;
                      }
                    }
                    if (isPresent) {
                      obj = {
                        ...item,
                        "CategorySelected": true,
                        "ContactLevel": item.ContactLevel.map(contactId => ({
                          "contactId": contactId.contactId,
                          "contactSelected": str.includes(contactId.contactId.toString())
                        }))
                      }
                    } else {
                      obj = {
                        ...item
                    }
                }
                    return obj
                  });
                  console.log("tempArr", tempArr)
                  // updateParentEmergencyContact(tempArr)
                  setEmergencyContactList(tempArr)
                  setCategoryMaster(tempArr)
        
                } else {
                  // updateParentEmergencyContact([])
                  setCategoryMaster([])
                  setEmergencyContactList([])
                }
              })
                .catch((err) => console.log(err));
        
            } else {
              // updateParentEmergencyContact([])
              setCategoryMaster([])
              setEmergencyContactList([])
            }
    }, [siteListString]);

    // for Emergency Contact
    useEffect(() => {
      const transformed = categoryMaster
        .filter(item => item.CategorySelected)
        .map(item => ({
          categoryChecked: item.Category.toString(),
          contactLevels: item.ContactLevel.filter(contact => contact.contactSelected)
            .map(contact => contact.contactId.toString())
            .toString()
        }));
      console.log("transformed", transformed)
      setTransformedData(transformed); // Store transformed data in state

    }, [categoryMaster]);

    // for Custom Contact
    useEffect(() => {
      console.log("mainCustomerListParent", mainCustomerList)
      const CustomData = mainCustomerList.map((item) => {
        return {
          ...item,
          Id: item.Id.toString(),
        };
      });
      console.log("CustomData", CustomData)
      setTempCustomContact(CustomData); // Store the transformed data in state
    }, [mainCustomerList]);

    
    useEffect(() => {
      console.log("DataEsclationLevels transformed", transformedData)
  
        if (level && setEscalationLevels) {
            console.log("DataEsclationLevels I am called from transformedData");
            console.log("DataEsclationLevels level from transformedData", level);
            
            handleLevelChange(level, "EscalationContactDetails", transformedData);
        }
    }, [transformedData]);
    
    
    useEffect(() => {
      console.log("DataEsclationLevels userlist", selectedUsersList);
      
      if (level && setEscalationLevels) {
            console.log("DataEsclationLevels I am called from selectedUsersList");
            console.log("DataEsclationLevels level from selectedUsersList", level);
            handleLevelChange(level, "EscalationUserDetails", selectedUsersList);
        }
    }, [selectedUsersList]);

    useEffect(() => {
      console.log("DataEsclationLevels tempCustomContact", tempCustomContact)
        
        if (level && setEscalationLevels) {
            console.log("DataEsclationLevels I am called from tempCustomContact");
            console.log("DataEsclationLevels level from tempCustomContact", level);
            
            handleLevelChange(level, "EscalationCustomContactDetails", tempCustomContact);
        }
    }, [tempCustomContact]);


    // useEffect(() => {
    //   console.log("parentSelectedUsersList", parentSelectedUsersList)
    //   setSelectedUsersList(parentSelectedUsersList);;
    // }, [parentSelectedUsersList]);

    // useEffect(() => {
    //   console.log("parentEmergencyContact", parentEmergencyContact)
    //   setCategoryMaster(parentEmergencyContact);
    // }, [parentEmergencyContact]);

    // useEffect(() => {
    //   console.log("parentCustomContact", parentCustomContact)
    //   setCustomContact(parentCustomContact);;
    // }, [parentCustomContact]);

    // useEffect(() => {
    //   console.log("parentMainCustomerList", parentMainCustomerList)
    //   setMainCustomerList(parentMainCustomerList);;
    // }, [parentMainCustomerList]);

    // useEffect(() => {
    //   console.log("parentCount", parentCount)
    //   setCount(parentCount);;
    // }, [parentCount]);

    // useEffect(() => {
    //   console.log("selectedEmergCont", selectedEmergCont)
    // }, [selectedEmergCont]);

    // function part Start

    const onAddClick = (e) => {
        e.preventDefault();
        let lastForm = mainCustomerList[mainCustomerList.length - 1];
        let contactEmailEntered = lastForm?.ContactEmail;
        let contactNumberEntered = lastForm?.ContactNumber;
        const emailPattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;
    
        if (enableAdd) {
          WarningToast("Please complete the contact details to add another");
          return;
        } else {
          console.log(
            "Button Clicked",
            count,
            contactEmailEntered,
            contactNumberEntered
          );
          if (
            contactEmailEntered != undefined &&
            contactNumberEntered != undefined
          ) {
            if (emailPattern.test(contactEmailEntered)) {
            } else {
              ErrorToast("Please enter email id properly");
              return;
            }
            if (contactNumberEntered.length != 10) {
              ErrorToast("Please enter contact number properly");
              return;
            }
          }
        }
        
        let c = count + 1;
        let tempObj = {
          Id: c,
          Name: "",
          Designation: "",
          ContactNumber: "",
          ContactEmail: "",
        };
        let tempArr = mainCustomerList;
        tempArr.push(tempObj);
        setMainCustomerList(tempArr);
        // updateParentMainCustomerList(tempArr)
        setCustomContact(tempArr);
        // updateParentCustomContact(tempArr);
        setCount(c);
        // updateParentCount(c)
    };
  
    const onDeleteClick = (e, id) => {
      e.preventDefault();
      let temp = customContact.filter((item) => item.Id == id);
      if (
        temp[0].Name === "" ||
        temp[0].Designation === "" ||
        temp[0].ContactNumber === "" ||
        temp[0].ContactEmail === ""
      ) {
        setEnableAdd(false);
      }
      let arr = mainCustomerList.filter((item) => item.Id != id);
      setMainCustomerList(arr);
      updateParentMainCustomerList(arr)
      let arrTemp = customContact.filter((item) => item.Id != id);
      setCustomContact(arrTemp);
      updateParentCustomContact(arrTemp)
    };

        
    return(
     <Accordion key={level.EscalationLevel} style={{ width: "100%" }}>
        <Card>
            <Accordion.Toggle
                as={Card.Header}
                disabled={!isNotifFormEnabled}
                eventKey={level.EscalationLevel.toString()}
                className="NotificationCardAccordion"
                style={{ padding: "0.6rem 1.25rem" }}
                onClick={() => handleAccordionToggle(level.EscalationLevel)}
            >
                <p>{level.EscalationLevelName}</p>
                <div>
                    <button
                    disabled={!isNotifFormEnabled} 
                    type="button" 
                    onClick={() => { handleRemoveLevel(level.EscalationLevel)}}
                     style={{color:"red", backgroundColor: "transparent" }}>
                        Remove
                    </button>
                    <img
                        src={accOpen === level.EscalationLevel ? ArrowUp : ArrowDown}
                        alt={accOpen === level.EscalationLevel ? 'up arrow' : 'dropdown-arrow'}
                    />
                </div>
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={level.EscalationLevel.toString()}>
                <Card.Body style={{ padding: "10px" }}>
                    <div className="mt20" style={{ float: "left", width: "100%" }}>
                      <p className="SiteNameText escalationText">Wait Time</p>
                        <div className="inputTypeLabelContainer" style={{ float: "left", width: "100%", boxSizing: "border-box" }}>
                          <input className="inputType"
                           type='time'
                           step={2}
                           style={{ fontSize: "14px" }}
                           value={level.EscalationDueTime || ""}
                           disabled={!isNotifFormEnabled}
                           onChange={(e) => {
                            const newTime = e.target.value; 
                            const timeParts = newTime.split(":");
                            const selectedTime = `${timeParts[0]}:${timeParts[1]}:00`; // Add default seconds (00)
                            console.log("selectedTime", selectedTime);
                            handleLevelChange(level, "EscalationDueTime", selectedTime);
                           }} 
                          />
                        </div>
                    </div>

                    <div className="mt20" style={{ float: "left", width: "100%" }}>
                        <p className="SiteNameText escalationText">Email Notification Template</p>
                        <div className="NotificationEmailMsgBox">
                            <div className="tab-content">
                                <div className="startDiv">
                                    <MentionsInput
                                        style={mentionsInputStyles}
                                        singleLine
                                        placeholder="Enter Subject here"
                                        disabled={!isNotifFormEnabled}
                                        value={level.emailSubject}  
                                        onChange={(e, newValue, newPlainTextValue) => {
                                            // Call handleLevelChange with the appropriate parameters
                                            handleLevelChange(level, "emailSubject", newPlainTextValue);
                                        }}
                                    >
                                        <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                    </MentionsInput>
                                </div>
                                <div className="EmailDivideLine"></div>
                                <div className="mentionDiv">
                                    <MentionsInput
                                        style={mentionsInputStyles}
                                        placeholder="Enter message details here"
                                        disabled={!isNotifFormEnabled}
                                        rows={5}
                                        value={level.emailBody}  
                                        onChange={(e, newValue, newPlainTextValue) => {
                                            // Call handleLevelChange with the appropriate parameters
                                            handleLevelChange(level, "emailBody", newPlainTextValue);
                                        }}
                                    >
                                        <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                    </MentionsInput>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* SMS Section */}
                    <div className="mt08" style={{ float: "left", width: "100%" }}>
                        <p className="SiteNameText escalationText">SMS</p>
                        <div className="NotificationEmailMsgBox">
                            <div className="tab-content">
                                <div className="mentionDiv">
                                    <MentionsInput
                                        style={mentionsInputStyles}
                                        placeholder="Enter message details here"
                                        disabled={!isNotifFormEnabled}
                                        rows={5}
                                        value={level.smsBody} 
                                        onChange={(e, newValue, newPlainTextValue) => {
                                            // Call handleLevelChange with the appropriate parameters
                                            handleLevelChange(level, "smsBody", newPlainTextValue);
                                        }}
                                    >
                                        <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                    </MentionsInput>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mobile Notification Section */}
                    <div className="mt08" style={{ float: "left", width: "100%" }}>
                        <p className="SiteNameText escalationText">Mobile Notification</p>
                        <div className="NotificationEmailMsgBox">
                            <div className="tab-content">
                                <div className="mentionDiv">
                                    <MentionsInput
                                        style={mentionsInputStyles}
                                        placeholder="Enter message details here"
                                        disabled={!isNotifFormEnabled}
                                        rows={5}
                                        value={level.mobileBody}  
                                        onChange={(e, newValue, newPlainTextValue) => {
                                            // Call handleLevelChange with the appropriate parameters
                                            handleLevelChange(level, "mobileBody", newPlainTextValue);
                                        }}
                                    >
                                        <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                    </MentionsInput>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <RegisteredUsers
                        selectedUsersList={selectedUsersList}
                        setSelectedUsersList={setSelectedUsersList}
                        isNotifFormEnabled ={isNotifFormEnabled}
                        userList={userList}
                        setUserList={setUserList}
                        siteListString={siteListString}
                        selectedAllRegUsers={selectedAllRegUsers}
                        setSelectedAllRegUsers={setSelectedAllRegUsers}
                        isDarkTheme={isDarkTheme}
                        setEscalationLevels={setEscalationLevels}
                        level={level}
                        setCount={setTempCount}
                    />

                    <EmergencyContact
                      selectedUsersList={selectedUsersList}
                      setSelectedUsersList={setSelectedUsersList}
                      isNotifFormEnabled={isNotifFormEnabled}
                      userList={userList} setUserList={setUserList}
                      siteListString={siteListString}
                      selectedAllRegUsers={selectedAllRegUsers}
                      setSelectedAllRegUsers={setSelectedAllRegUsers}
                      isDarkTheme={isDarkTheme}
                      categoryMaster={categoryMaster}
                      emergencyContactList={emergencyContactList}
                      setEmergencyContactList={setEmergencyContactList}
                      setCategoryMaster={setCategoryMaster}
                    />

                    <CustomContact
                        addNewClicked={addNewClicked}
                        customContact={customContact}
                        setCustomContact={setCustomContact}
                        onAddClick={onAddClick}
                        isNotifFormEnabled ={isNotifFormEnabled}
                        count={count}
                        mainCustomerList={mainCustomerList}
                        onDeleteClick={onDeleteClick}
                        setEnableAdd={setEnableAdd}
                        setMainCustomerList={setMainCustomerList}
                        isDarkTheme={isDarkTheme}
                    />
                    <div style={{ textAlign: "center",marginBottom:"10px" , display:"none"}}>
                         <button className="DataAccessEdit" style={{ width: "100px" }}>
                           <span className="ViewUpdate">Save</span>
                         </button>
                         <button className="DataAccessEdit" style={{ width: "100px" }}>
                          <span className="ViewUpdate">Edit</span>
                         </button>
                         <button className="DataAccessEdit" style={{ width: "100px" }}>
                          <span className="ViewUpdate">Update</span>
                         </button>
                         <button className="DataAccessEdit" style={{ width: "100px" }} type="submit">
                          <span className="ViewUpdate">Cancel</span>
                         </button>
                    </div>

                    <EditModalContainer
                        isDarkTheme={isDarkTheme}
                        isEditCustomer={isEditCustomer}
                        selectedEntity={selectedEntity}
                        setTopLeftCheck={setTopLeftCheck}
                        topLeftCheck={topLeftCheck}
                        selectAllHandler={selectAllHandler}
                        searchHandlerOne={searchHandlerOne}
                        midLeftCheck={midLeftCheck}
                        setMidLeftCheck={setMidLeftCheck}
                    />

                </Card.Body>
            </Accordion.Collapse>
        </Card>
      </Accordion>
    );
}
export default EscalationAccordian;